<template>
  <div class="relative" @keydown.esc="closeMenu()">
    <div class="mask" v-if="isOpen" @click="closeMenu()"></div>
    <button
      :aria-label="ariaLabel"
      :aria-expanded="isOpen ? 'true' : 'false'"
      @click="toggleMenu()"
      ref="more"
      :id="buttonId"
    >
      <span v-if="icon" class="prefix">
        <doe-icon :icon="icon" size="small" />
      </span>
      <span :class="{ 'pl-1': icon, 'pr-1': more }">
        {{ label }}
      </span>
      <span v-if="more" class="suffix">
        <doe-icon icon="chevronDown" size="small" />
      </span>
    </button>
    <ul
      v-show="isOpen"
      class="absolute cursor-pointer align-middle bg-white border border-blue-900 rounded font-sans subpixel-antialiased text-base text-blue-900 leading-tight inline-block text-left w-10 z-50"
    >
      <li
        class="block font-light font-sans leading-loose subpixel-antialiased text-base text-black"
        v-for="(action, index) in actions"
        :key="index"
      >
        <button
          class="text-left p-3 w-full"
          ref="option"
          @click="handleAction(action.action)"
          @focus="focus = true"
          @blur="index === actions.length - 1 ? focus = false : false"
          @keydown.esc="closeMenu()"
        >
          {{ action.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import DoeIcon from "@/components/icon/Icon";

export default {
  name: "NavigationContext",
  props: {
    icon: {
      type: String
    },
    iconSize: {
      type: String,
      default: "medium",
      validator: value => {
        return ["large", "medium", "small", "mini"].indexOf(value) !== -1;
      }
    },
    label: {
      type: String
    },
    ariaLabel: {
      type: String
    },
    more: {
      type: Boolean
    },
    actions: {
      type: Array,
      required: true
    }
  },
  components: {
    DoeIcon
  },
  data() {
    return {
      isOpen: false,
      tabIndex: 0,
      focus: false
    };
  },
  watch: {
    focus(newVal) {
      if(newVal === false) {
        this.isOpen = !this.isOpen;
      }
    }
  },
  methods: {
    handleAction(action) {
      this.isOpen = false;
      this.$store.commit('SET_BUTTON', this.buttonId);
      this.$emit("click", {
        action: action
      });
    },
    handleKeyPress(index, e) {
      if (e.shiftKey) {
        this.tabIndex = index - 1;
        if (this.tabIndex < 0) {
          this.tabIndex = this.$refs.option.length - 1;
        }
      } else {
        this.tabIndex = index + 1;
        if (this.tabIndex > this.$refs.option.length - 1) {
          this.tabIndex = 0;
        }
      }
      this.$refs.option[this.tabIndex].focus();
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
      this.$refs.more.focus();
    }
  },
  computed: {
    buttonId() {
      return `id${Math.random()}`;
    },
    showMore() {
      if (this.more) {
        return "chevronDown";
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.1);
  top: 44px;
  right: 0;
}
li:last-of-type {
  @apply border-0 border-t border-gray-500;
}
li button {
  @apply px-3 w-full;
}
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 49;
}
button {
  @apply cursor-pointer text-blue-900 font-sans font-semibold select-none w-full;
  svg {
    @apply fill-current;
  }
  @screen md {
    @apply w-auto;
  }
  @apply leading-snug py-2 min-w-sm text-base;
  @apply font-light px-0 min-w-auto;
  height: 44px;
  min-width: 44px;
}
</style>
